import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';

import { getDateFormat } from './getDateFormat';
// Types
import type { DateFormat } from './types';

/**
 * @param formatStr
 */
export function formatCurrentDate(formatStr?: DateFormat): string {
  const now = new Date().toISOString();
  const ISO8601Format = "yyyy-MM-dd'T'HH:mm:ss.SSSX";
  const parsedDate = parse(now, ISO8601Format, new Date());
  return format(parsedDate, getDateFormat(formatStr));
}
